import { Tooltip, withStyles } from "@material-ui/core";

export const LightTooltip = withStyles((theme) => ({
    tooltip: {
      backgroundColor: "#FFFCD1",
      color: "rgba(0, 0, 0, 0.9)",
      fontSize: 11,
    },
  }))(Tooltip);


// WEBPACK FOOTER //
// ./src/Pages/Stock/LightTooltip.jsx